<template>
  <svg width="24px" height="24px"
       viewBox="0 0 24 24" version="1.1"
       xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>atoms/icons/24x24/check/black</title>
    <g id="atoms/icons/24x24/check/black" stroke="none"
       stroke-width="1"
       fill-rule="evenodd">
      <path d="M9.42253967,17.6577085 L3.76568542,12.0008542 C3.45326599,11.6884348 3.45326599,11.1819028 3.76568542,10.8694834 C4.07810486,10.557064 4.58463684,10.557064 4.89705627,10.8694834 L9.99937085,15.9713708 L19.0627417,6.90968542 C19.3751611,6.59726599 19.8816931,6.59726599 20.1941125,6.90968542 C20.506532,7.22210486 20.506532,7.72863684 20.1941125,8.04105627 L10.5774603,17.6577085 C10.4354515,17.7997173 10.2533368,17.8771767 10.067576,17.8900866 L9.93242396,17.8900866 C9.74666324,17.8771767 9.56454851,17.7997173 9.42253967,17.6577085 Z" id="Combined-Shape"
      ></path>
    </g>
  </svg>
</template>
<script setup>
// dummy comment to surpress rollup build errors with dynamic imports
// if the file doesn't contain a script tag with content, the build fails.
</script>
